import { MobileNavbar } from "./MobileNavbar";
import { AnimatePresence, motion } from "framer-motion";
import clsx from "clsx";
import { XMarkIcon } from "@heroicons/react/24/outline";
import { parentSectionAtom, sidebarOpenAtom } from "../state";
import { useAtom } from "jotai";
import { Menu } from "./Menu";
import { SidebarProps } from "./Sidebar";

export const MobileSidebarV2 = ({ parentSections }: SidebarProps) => {
    const [sidebarOpen, setSidebarOpen] = useAtom(sidebarOpenAtom);
    const [parentSection, setParentSection] = useAtom(parentSectionAtom);

    return (
        <>
            <MobileNavbar onMenuClick={() => setSidebarOpen(true)} />
            <AnimatePresence>
                <motion.div
                    initial={{ x: sidebarOpen ? 0 : "-100%" }}
                    animate={{ x: sidebarOpen ? 0 : "-100%" }}
                    exit={{ x: sidebarOpen ? 0 : "-100%" }}
                    transition={{
                        type: "spring",
                        damping: 30,
                        stiffness: 300,
                        duration: 0.3,
                    }}
                    className={clsx(
                        "fixed inset-0 z-50",
                        "flex flex-col bg-slate-800 text-white",
                        "lg:hidden",
                    )}
                >
                    <div
                        className={clsx(
                            "p-6",
                            "flex items-center justify-between",
                        )}
                    >
                        <div className="flex items-start gap-1">
                            <Menu
                                options={parentSections || []}
                                selectedValue={parentSection}
                                onValueChange={(value) =>
                                    setParentSection(value)
                                }
                            />
                        </div>
                        <button
                            onClick={() => setSidebarOpen(false)}
                            className="menu-item rounded-lg p-1 transition-colors"
                            aria-label="Close menu"
                        >
                            <XMarkIcon className="size-6" />
                        </button>
                    </div>

                    <div
                        className={clsx(
                            "p-6",
                            "flex flex-1 flex-col",
                            "overflow-hidden",
                        )}
                    >
                        <div id="mobile-sidebar-header" />
                        <div
                            id="mobile-sidebar-content"
                            className="flex min-h-0 flex-1 flex-col"
                        />
                    </div>
                </motion.div>
            </AnimatePresence>
        </>
    );
};
